<template>
  <div id="plex-footer" v-if="showFooter">
    <div :class="['footer-content', {'activity-padding': ['/', '/download'].includes($route.path)}]">
      <div class="link-content">
        <ul>
          <li class="title">{{ $t("aboutUs") }}</li>
          <li>
            <router-link to="/user-agreement">{{
              $t("userAgreement")
            }}</router-link>
          </li>
          <li>
            <router-link to="/affiliate-program">{{
              $t("affiliate")
            }}</router-link>
          </li>
        </ul>
        <ul class="download">
          <li class="title">{{ $t("download") }}</li>
          <li>
            <router-link to="/download?platform=windows">Windows</router-link>
          </li>
          <li><router-link to="/download?platform=mac">macOS</router-link></li>
          <li><router-link to="/download?platform=ios">iOS</router-link></li>
          <li>
            <router-link to="/download?platform=android">Android</router-link>
          </li>
          <li>
            <router-link to="/download?platform=ubuntu">Linux</router-link>
          </li>
          <li>
            <router-link to="/download?platform=androidTV"
              >Android TV</router-link
            >
          </li>
        </ul>
        <choose-lang-in-footer></choose-lang-in-footer>
        <ul class="help" :style="{ '--positionTop': height }">
          <li class="title">{{ $t("help") }}</li>
          <li><span>iplexservice@gmail.com</span></li>
          <li>
            <router-link to="/faq">{{ $t("faq") }}</router-link>
          </li>
        </ul>
        <ul class="join-us">
          <li class="title">{{ $t("joinUs") }}</li>
          <li>
            <a
              rel="noopener noreferrer"
              href="https://www.facebook.com/groups/plexvpn/"
              target="_blank"
              class="facebook-link"
              >Facebook</a
            >
          </li>
        </ul>
      </div>
      <hr />
      <p class="warning">{{ $t("warning") }}</p>
    </div>
  </div>
</template>

<script>
import ChooseLangInFooter from "../chooseLangInFooter/ChooseLangInFooter.vue";
import locales from "./lang";

export default {
  name: "plex-footer",
  locales,
  components: { ChooseLangInFooter },
  data() {
    return {
      showFooter: true,
      height: 0,
    };
  },
  computed: {
    mediaType() {
      return this.$store.state.mediaType;
    },
  },
  mounted() {
    // this.getHeight() //get element(.download) height
  },
  methods: {
    getHeight() {
      let height =
        (document.getElementsByClassName("download")[0].offsetHeight + 40) /
          100 +
        "rem";
      this.height = height;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "footer";
</style>



// WEBPACK FOOTER //
// Footer.vue?66792236